import React from "react";
import Card from "./Card";
import {
  IconCube,
  IconDial,
  IconBranch,
  IconShield,
  IconColumn,
} from "./icons";
import BookCTA from "./BookCTA";
import "./ServicesSection.css";

/* Content preserved verbatim from the pre-redesign ConsultContent. */
const services = [
  {
    title: "Build Specialized AI Products",
    description:
      "We design and build custom AI solutions tailored to your domain and workflows. From prototypes to production, we handle data, models, integration, and deployment.",
    icon: <IconCube />,
  },
  {
    title: "AI Optimization Workshops",
    description:
      "Hands-on sessions to tune your AI stack for accuracy, latency, and cost. We profile bottlenecks and apply prompt, model, and infrastructure optimizations.",
    icon: <IconDial />,
  },
  {
    title: "AI Strategy Development",
    description:
      "Collaboratively define an AI roadmap aligned with business goals. We prioritize use cases, ROI, architecture, and build-vs-buy decisions.",
    icon: <IconBranch />,
  },
  {
    title: "AI Readiness Assessments",
    description:
      "Evaluate data, infrastructure, security, and organizational readiness for AI adoption. Receive a gap analysis and phased recommendations.",
    icon: <IconShield />,
  },
  {
    title: "Leadership Training and Debriefs on Current State of AI",
    description:
      "Executive briefings on the latest AI capabilities, risks, and regulations. Practical guidance on governance, change management, and responsible adoption.",
    icon: <IconColumn />,
  },
];

const ServicesSection = () => (
  <section
    id="services"
    className="section services"
    style={{ "--section-bg": "var(--bg-secondary)" }}
  >
    <div className="container">
      <div className="section-header">
        <p className="eyebrow">What We Do</p>
        <h2>Expert AI Services</h2>
        <p className="section-sub">
          An engineering and AI company. We build custom AI products, provide
          AI consulting, and offer AI training.
        </p>
        <BookCTA
          ctaLocation="services_section"
          className="btn-secondary services-cta"
        >
          Book a FREE Consultation Today
        </BookCTA>
      </div>

      <div className="services-grid">
        {services.map((s) => (
          <Card
            key={s.title}
            title={s.title}
            description={s.description}
            icon={s.icon}
          />
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
